import { useContext } from 'react';

import { SzafirServiceContext } from '../szafir';

export const useSzafir = () => useContext(SzafirServiceContext);
